/**
 * Shared text extraction + word counting (T-032).
 *
 * `extractTextFromContent` was previously defined inline in ChatSidebar; it is
 * hoisted here so WordCountBar and the chat context estimator share one source.
 * `countWords` mirrors the backend `count_words` (whitespace split).
 */

/**
 * Flatten a sheet's content (ProseMirror JSON doc or a plain string) to text.
 */
export function extractTextFromContent(content) {
  if (!content) return '';

  if (typeof content === 'string') {
    return content;
  }

  if (typeof content === 'object' && content.type === 'doc') {
    const extractText = (node) => {
      if (!node) return '';
      if (node.text) return node.text;
      if (node.content && Array.isArray(node.content)) {
        return node.content.map(extractText).join(' ');
      }
      return '';
    };
    return extractText(content);
  }

  return '';
}

/**
 * Count words the same way the backend does: trim, split on whitespace runs,
 * drop empties. Empty/blank input → 0.
 */
export function countWords(text) {
  return (text || '').trim().split(/\s+/).filter(Boolean).length;
}
